const STANDARDHARDWARES = [
  {
    name: "Stud mount",
    code: "Stud_Mount_2A",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000001/pbl-stud.jpg",
    pattern: "Drill pattern",
    upcharge: 0,
  },
  {
    name: "Pad mount",
    code: "Pad_Mount_2B",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000001/pbl-pad.jpg",
    pattern: "Spacing guide",
    upcharge: 0,
  },
  {
    name: "Combo mount",
    code: "Combo_Mount_2C",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000001/pbl-combo.jpg",
    pattern: "Spacing guide",
    upcharge: 0,
  },
  {
    name: "Combo All mount",
    code: "Combo_All_Mount_2D",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000001/pbl-comboall.jpg",
    pattern: "Spacing guide",
    upcharge: 0,
  },
];

const METALHARDWARES = [
  {
    name: "Stud mount",
    code: "Stud_Mount_2A",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000001/pbl-stud.jpg",
    pattern: "Drill pattern",
    upcharge: 0,
  },
];

const BL1000HARDWARES = [
  {
    name: "Stud mount",
    code: "Mounting_Stud",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000001/pbl-stud.jpg",
    pattern: "Drill pattern",
    upcharge: 0,
  },
  {
    name: "Pad mount",
    code: "Mounting_Pad",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000001/pbl-pad.jpg",
    pattern: "Spacing guide",
    upcharge: 0,
  },
  {
    name: "Combo mount",
    code: "Mounting_Combo",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000001/pbl-combo.jpg",
    pattern: "Spacing guide",
    upcharge: 0,
  },
  {
    name: "Combo All mount",
    code: "Mounting_Combo_All",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000001/pbl-comboall.jpg",
    pattern: "Spacing guide",
    upcharge: 0,
  },
];

const ACRYLICHARDWARES = [
  {
    name: "Plain mount",
    code: "Mounting_Plain",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000010/bl4-plain.jpg",
    pattern: "Spacing guide",
    upcharge: 0,
  },
  {
    name: "Flush stud mount",
    code: "Mounting_Flush_Stud",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000010/bl4-flush-stud.jpg",
    pattern: "Drill pattern",
    upcharge: 0,
  },
  {
    name: "Glued stud mount",
    code: "Mounting_Glued_Stud",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000010/bl4-stud.jpg",
    pattern: "Drill pattern",
    upcharge: 0,
  },
  {
    name: "Pad mount",
    code: "Mounting_Pad",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000010/bl4-pad.jpg",
    pattern: "Spacing guide",
    upcharge: 0,
  },
  {
    name: "Combo mount",
    code: "Mounting_Combo",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000010/bl4-combo.jpg",
    pattern: "Spacing guide",
    upcharge: 0,
  },
  {
    name: "Combo All mount",
    code: "Mounting_Combo_All",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000010/bl4-comboall.jpg",
    pattern: "Spacing guide",
    upcharge: 0,
  },
  {
    name: "Double sided tape",
    code: "Mounting_VHB_Tape",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000010/bl4-vhbtape.jpg",
    pattern: "Spacing guide",
    upcharge: 0,
  },
];

const PFL100HARDWARES = [
  {
    name: "Plain mount",
    code: "Mounting_Plain",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000010/bl4-plain.jpg",
    pattern: "Spacing guide",
    upcharge: 0,
  },
  {
    name: "Flush stud",
    code: "Mounting_Flush_Stud",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000010/bl4-flush-stud.jpg",
    pattern: "Drill pattern",
    upcharge: 0,
  },
  {
    name: "Double sided tape",
    code: "Mounting_VHB_Tape",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000010/bl4-vhbtape.jpg",
    pattern: "Spacing guide",
    upcharge: 0,
  },
];

const BL70HARDWARES = [
  {
    name: "Plain mount",
    code: "Mounting_Plain",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000010/bl4-plain.jpg",
    pattern: "Spacing guide",
    upcharge: 0,
  },
  {
    name: "Flush stud mount",
    code: "Mounting_Flush_Stud",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000010/bl4-flush-stud.jpg",
    pattern: "Drill pattern",
    upcharge: 0,
  },
  {
    name: "Double sided tape",
    code: "Mounting_VHB_Tape",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000010/bl4-vhbtape.jpg",
    pattern: "Spacing guide",
    upcharge: 0,
  },
];

export const PATTERNS = [
  {
    name: "Spacing guide",
    pattern: "Spacing guide",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000076/pattern-spacing-guide-500.jpg",
    width: 500,
    height: 109,
    brief:
      "An accurate, computer-generated pattern printed on 60 lb white grid paper that shows the outline of each character and spacing between letters. Used with pad mount or double face tape. Once taped to the wall, letters are set inside the cutout and adhered to the wall. Factory will determine if split or full stencil is best.",
  },
  {
    name: "Drill pattern",
    pattern: "Drill pattern",
    src: "https://www.alphabetsigns.com/mm5/graphics/00000076/pattern-drill.jpg",
    width: 455,
    height: 100,
    brief:
      "An accurate, computer-generated pattern printed on 60 lb white grid paper that shows the outline of each character, spacing between letters and hand punched hole locations of each stud showing where to drill.",
  },
];

export const HARDWARE_MAP = {
  BL1000: BL1000HARDWARES,
  BL2000: METALHARDWARES,
  BL2200: METALHARDWARES,
  ML1000: STANDARDHARDWARES,
  BL31000: METALHARDWARES,
  BL32000: METALHARDWARES,
  BL33000: METALHARDWARES,
  BL40100: ACRYLICHARDWARES,
  BL40200: ACRYLICHARDWARES,
  PFL100: PFL100HARDWARES,
  BL70100: BL70HARDWARES,
};

export const getHardwareByProductCode = (productCode) => {
  if (!productCode) {
    console.warn("No product code provided");
    return [];
  }
  const hardwares = HARDWARE_MAP[productCode];
  if (!hardwares) {
    console.warn(`No hardware defined for product code: ${productCode}`);
    return [];
  }
  return hardwares;
};
